'use client';

import React from 'react';

import { GeoLocationContext } from '@/contexts/geoLocationContext';

export const GeoLocationProvider = ({ children, value }: { children: React.ReactNode; value: any }) => (
  <GeoLocationContext.Provider value={value}>{children}</GeoLocationContext.Provider>
);
